import { render, staticRenderFns } from "./refund-order-history.vue?vue&type=template&id=245a18f6&scoped=true&"
import script from "./refund-order-history.vue?vue&type=script&lang=js&"
export * from "./refund-order-history.vue?vue&type=script&lang=js&"
import style0 from "./refund-order-history.vue?vue&type=style&index=0&id=245a18f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a18f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245a18f6')) {
      api.createRecord('245a18f6', component.options)
    } else {
      api.reload('245a18f6', component.options)
    }
    module.hot.accept("./refund-order-history.vue?vue&type=template&id=245a18f6&scoped=true&", function () {
      api.rerender('245a18f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-order-history-management/refund-order-history.vue"
export default component.exports